import React from "react";
import { EuiLink } from "@elastic/eui";
import AbstractColumnActions from "../../shared/entity/TableColumnAction";

const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        render: (item) => (
            <span>
                <EuiLink>#{item}</EuiLink>
            </span>
        ),
        sortable: true,
        width: 70,
    },
    {
        field: "email",
        name: "E-Mail",
        sortable: true,
    },
    {
        field: "updatedAt",
        dataType: "date",
        name: "Last login",
        sortable: true,
    },
    {
        field: "createdAt",
        dataType: "date",
        name: "Join Date",
        sortable: true,
    },
    {
        field: "assigneeType",
        dataType: "string",
        name: "Assignment Type",
        sortable: true,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];

export default columns;
